import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

// ngx-bootstrap modules
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TabsModule } from 'ngx-bootstrap/tabs';



import { ApiErrorComponent } from './api-error/api-error.component';
import { ImageComponent } from './image/image.component';
import { BusyLoadingComponent } from './busy-loading/busy-loading.component';
import { WorkInProgressComponent } from './work-in-progress/work-in-progress.component';
import { CourseApplicationsComponent } from './course-applications/course-applications.component';
import { ReferralListComponent } from './referral-list/referral-list.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { NoteComponent } from './note/note.component';
import { AttachmentComponent } from './attachment/attachment.component';
// google reCaptcha
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import {MatSelectModule} from '@angular/material/select';

import { TableWrapperComponent } from './table-wrapper/table-wrapper.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModalComponent } from './app-modal/modal.component';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {MatTabsModule} from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ToastService } from './service/toast.service';
import { MatSortModule } from '@angular/material/sort';
import { ScreenAccessDirective } from './directive/screen-access.directive';
import { MatTreeModule } from '@angular/material/tree';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { AdmissionRequirementsComponent } from './admission-requirements/admission-requirements.component';
import { MultiSelectDropdownComponent } from './multi-select-dropdown/multi-select-dropdown.component';
import { SingleSelectDropdownComponent } from './single-select-dropdown/single-select-dropdown.component';
import { DayTimeSelectorComponent } from './day-time-selector/day-time-selector.component';
import { DynamicFormFieldsComponent } from './dynamic-form-fields/dynamic-form-fields.component';
import { StudentTransferComponent } from './student-transfer/student-transfer.component';

// google maps

// TO DO: Need To enable
//import { AgmCoreModule } from '@agm/core';


@NgModule({
  declarations: [
    ApiErrorComponent,
    ImageComponent,
    BusyLoadingComponent,
    WorkInProgressComponent,
    CourseApplicationsComponent,
    ReferralListComponent,
    ConfirmationModalComponent,
    NoteComponent,
    AttachmentComponent,
    TableWrapperComponent,
    MultiSelectDropdownComponent,
    SingleSelectDropdownComponent,
    DayTimeSelectorComponent,
    ModalComponent,
    ScreenAccessDirective,
    AdmissionRequirementsComponent,
    DynamicFormFieldsComponent,
    StudentTransferComponent

  ],
  providers: [
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'always'}},
    provideNgxMask(),
    ToastService
  ],

  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    BsDropdownModule,
    BsDatepickerModule,
    TooltipModule,
    ModalModule,
    NgxMaskDirective,
    NgxPaginationModule,
    PaginationModule,
    TypeaheadModule,
    TabsModule,
    //AgmCoreModule, // TO DO: Need To enable
    RecaptchaModule,  //this is the recaptcha main module
    RecaptchaFormsModule, //this is the module for form incase form validation
    TranslateModule.forChild(),
    MatStepperModule,
    MatDialogModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatCardModule,
    MatTabsModule,
    MatMenuModule,
    MatSlideToggle,
    MatPaginatorModule,
    MatInputModule
  ],

  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule,
    BsDatepickerModule,
    TooltipModule,
    ModalModule,
    NgxMaskDirective,
    NgxPaginationModule,
    PaginationModule,
    TypeaheadModule,
    TabsModule,
    //AgmCoreModule, // TO DO: Need To enable
    RecaptchaModule,  //this is the recaptcha main module
    RecaptchaFormsModule, //this is the module for form incase form validation
    TranslateModule,
    ApiErrorComponent,
    ImageComponent,
    BusyLoadingComponent,
    CourseApplicationsComponent,
    ReferralListComponent,
    ConfirmationModalComponent,
    NoteComponent,
    AttachmentComponent,
    TableWrapperComponent,
    ScreenAccessDirective,
    AdmissionRequirementsComponent,
    MultiSelectDropdownComponent,
    SingleSelectDropdownComponent,
    DayTimeSelectorComponent,
    DynamicFormFieldsComponent,
    MatStepperModule,
    MatDialogModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatCardModule,
    MatTabsModule,
    MatTableModule,
    MatCheckboxModule,
    MatButtonModule,
    MatMenuModule,
    MatSlideToggle,
    MatPaginatorModule,
    MatSortModule,
    MatTreeModule,
    MatInputModule,
    StudentTransferComponent
  ]
})
export class SharedModule { }
